import { AppBar, Grid, Link } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { AppColors } from "../resources/AppColors";
import { CommonTexts } from "../locale/es";


const useStyles = makeStyles((theme) => ({
  footer: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <AppBar
      position="fixed"
      className={classes.footer}
      style={{
        top: "auto",
        bottom: 0,
        color: AppColors.WHITE,
        background: AppColors.PRIMARY,
      }}
    >
      <Grid container sx={{ py: 2 }} >
        <Grid item xs={4} display='inherit' justifyContent='center' alignItems='center'>
          <Link
            href="https://www.uhda.health"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{ color: "white", textAlign: 'center' }}
          >
            {CommonTexts.ABOUT}
          </Link>
        </Grid>
        <Grid item xs={4} display='inherit' justifyContent='center' alignItems='center' >
          <Link
            href="https://www.universaldoctor.com/privacypolicyuhdamonitoring"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{ color: "white", textAlign: 'center' }}
          >
            {CommonTexts.TERMS}
          </Link>
        </Grid>
        <Grid item xs={4} display='inherit' justifyContent='center' alignItems='center' >
          <Link
            href="https://www.universaldoctor.com/privacypolicyuhdamonitoring"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{ color: "white", textAlign: 'center' }}
          >
            {CommonTexts.PRIVACY}
          </Link>
        </Grid>
      </Grid>
    </AppBar>
  )
}

export default Footer